import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import Card from './Card';
import Button from './Button';
import type { Achievement } from '../../store/types';

interface CelebrationOverlayProps {
  achievement: Achievement;
  onClose: () => void;
}

const CelebrationOverlay: React.FC<CelebrationOverlayProps> = ({ achievement, onClose }) => {
  useEffect(() => {
    const duration = 3 * 1000;
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 3000 };

    const randomInRange = (min: number, max: number) => Math.random() * (max - min) + min;

    const interval: any = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / duration);
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
    }, 250);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(2, 6, 23, 0.9)',
      zIndex: 2500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--spacing-lg)',
      backdropFilter: 'blur(10px)'
    }}>
      <Card style={{ 
        width: '100%', 
        maxWidth: '400px', 
        textAlign: 'center',
        padding: 'var(--spacing-xl)',
        border: '2px solid var(--accent-primary)',
        boxShadow: '0 0 30px var(--accent-glow)'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: 'var(--spacing-md)' }}>{achievement.icon}</div>
        <h1 className="text-accent" style={{ fontSize: '2rem', fontWeight: 900, marginBottom: 'var(--spacing-sm)' }}>
          {achievement.title.toUpperCase()}
        </h1>
        <p className="text-primary" style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 'var(--spacing-xl)' }}>
          {achievement.description}
        </p>
        <Button fullWidth size="lg" onClick={onClose}>AWESOME!</Button>
      </Card>
    </div>
  );
};

export default CelebrationOverlay;
